// The backend's AccessClass ladder (app/services/access_policy.py), lowest tier first. Every tier is
// mintable — the validator accepts any AccessClass name and create_api_key caps it to the minter's
// own live role — so this is both the create form's option list and the union the listing renders.
export const ACCESS_CEILINGS = [
  "PUBLIC",
  "USER",
  "SALES_READ",
  "SALES_WRITE",
  "SUPER",
] as const;

export type AccessCeiling = (typeof ACCESS_CEILINGS)[number];

export interface ApiKey {
  id: number;
  name: string;
  access_ceiling: AccessCeiling;
  account_id: number;
  account_email: string;
  created_by_account_id: number | null;
  revoked_by_account_id: number | null;
  created_at: string;
  expires_at: string | null;
  revoked_at: string | null;
  last_used_at: string | null;
  is_active: boolean;
}

// The backend requires an explicit expiry decision: either a concrete expires_at OR
// never_expires=true. Sending neither (or both) is a validation error.
export interface CreateApiKeyRequest {
  name: string;
  access_ceiling: AccessCeiling;
  expires_at: string | null;
  never_expires: boolean;
  // The account the key acts as, by email. Omit or send null to mint for your own account (the
  // default); the UI sends null for a blank field. A super_admin may name any other account; the
  // backend rejects a ceiling above that account's live role, so the key grants no authority the
  // target account doesn't already have.
  account_email?: string | null;
}

export interface CreateApiKeyResponse {
  api_key: ApiKey;
  plaintext_key: string;
}
